module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "hello"
  }, [_h('div', [_h('div', {
    staticClass: "calc_name"
  }, [_h('span', {
    staticClass: "font_name"
  }, [_vm._s(_vm.name)])]), " ", " ", _h('div', {
    staticClass: "clear"
  })]), " ", _h('div', [_h('div', {
    staticClass: "minus_value"
  }, [_h('div', [_h('ul', {
    class: _vm.minus > 0 ? 'font_red' : 'font_green',
    staticStyle: {
      "text-align": "left",
      "padding-top": "20px"
    }
  }, [_h('li', {
    staticClass: "font_minus"
  }, [" " + _vm._s(_vm.minus > 0 ? '+' + _vm.minus : _vm.minus)]), " ", _h('li', {
    staticClass: "font_unit"
  }, [_vm._s(_vm.unit)])]), " ", _h('ul', {
    staticStyle: {
      "padding-top": "22px"
    }
  }, [_h('li', {
    staticClass: "font_value"
  }, [_vm._s(_vm.value[0])]), _h('li', {
    staticClass: "font_unit_s"
  }, [_vm._s(_vm.unit)]), " ", _h('li', {
    class: _vm.minus > 0 ? 'accow_red' : 'accow_green'
  }), " ", _h('li', {
    staticClass: "font_value"
  }, [_vm._s(_vm.value[1])]), _h('li', {
    staticClass: "font_unit_s"
  }, [_vm._s(_vm.unit)])])])]), " ", (_vm.minus === 0) ? _h('div') : _h('div', {
    class: _vm.minus > 0 ? 'arrow_big_red' : 'arrow_big'
  }), " ", " ", _h('div', {
    staticClass: "clear"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-74225b9e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Calc.vue
// module id = 27
// module chunks = 1